
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type { CoreContentType } from "../system/index.js";

/**
 * 🔗 Nav // External Link
 *
 * Id: a5b91b88-4c2d-4436-a5a6-06068203410a
 * Codename: external_link
 */
export type NavExternalLink = CoreContentType<
    NavExternalLinkElementCodenames,
    {
        /**
         * Label
         *
         * Type: text
         * Required: true
         * Codename: label
         * Id: 3054f547-428c-445b-9f7e-689a9785bc3b
         */
        readonly label: Elements.TextElement;
        /**
         * URL
         *
         * Type: text
         * Required: true
         * Codename: url
         * Id: 19d8e9d8-c12b-49d6-a410-c6645039f99e
         */
        readonly url: Elements.TextElement;
    },
    'external_link'
>;

/**
 * Type representing all available element codenames for 🔗 Nav // External Link
 */
export type NavExternalLinkElementCodenames = 'label' | 'url';

/**
 * Type guard for 🔗 Nav // External Link
 *
 * Id: a5b91b88-4c2d-4436-a5a6-06068203410a
 * Codename: external_link
 */
export function isNavExternalLink(item: CoreContentType | undefined | null): item is NavExternalLink {
    return item?.system?.type === 'external_link';
}
